import { extend, setInteractionMode } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import messages from "vee-validate/dist/locale/en.json";

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule], // assign message
  });
});

extend("confirm-nocase", {
  params: ["target"],
  validate: (value, { target }) => {
    return value.toLowerCase() === target.toLowerCase();
  },
  message: messages.confirmed,
});

setInteractionMode("eager");

extend("alpha_dash_num_symbols", {
  validate: (value) => {
    // eslint-disable-next-line no-control-regex
    const regex = /^[\u0000-\u007F]+$/;
    return regex.test(value);
  },
  message:
    "Please only use A-Z, 0 - 9, & symbols in your Gift Note or printing will error.",
});

setInteractionMode("eager");
